import PropTypes from 'prop-types';
import { Box, Typography, Avatar, IconButton } from "@mui/material";
import { Edit } from '@mui/icons-material';
import { ReactComponent as DefaultUser } from '../../assets/ic_default_user.svg';

LoggedCard.propTypes = {
    user: PropTypes.object,
    onEdit: PropTypes.func
};

export default function LoggedCard({ user, onEdit }) {
    console.log('user', user);

    return (
        <>
            <Avatar alt="User Photo">
                {user && user.photoUrl ? (
                    <img src={user.photoUrl} alt="photoUrl" style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
                ) : (
                    <DefaultUser />
                )}
            </Avatar>
            <Box sx={{ ml: 2, flex: 1 }}>
                <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                    {user && user.fullName}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {user && user.rollName}
                </Typography>
            </Box>
            {onEdit && (
                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        onEdit();
                    }}
                    sx={{ ml: 2 }}
                >
                    <Edit fontSize="small" />
                </IconButton>
            )}
        </>
    );
};